// in App.js
import React, { Component } from 'react';
import pgDataProvider from './ra-postgraphile-factory.js'
// ListGuesser not needed but usefull for now
import { Admin, Resource, ListGuesser } from 'react-admin';
import { createMuiTheme } from '@material-ui/core/styles';

import { ClientCreate, ClientEdit, ClientList, ClientShow } from './clients';
import { IdpCreate, IdpEdit, IdpList, IdpShow } from './idps';
import { ScopeCreate, ScopeEdit, ScopeList, ScopeShow } from './scopes';
import { RuleCreate, RuleEdit, RuleList, RuleShow } from './rules';
import authProvider from './authProvider';
import loginPage from './loginpage';
import Dashboard from './dashboard';
import { __schema as schema } from './schema';

import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';


// Instantiate required constructor fields
const cache = new InMemoryCache();
const link = new HttpLink({
    uri: '/graphql',
});



const httpLink = new HttpLink({ uri: '/graphql' });

const permissionsLink = onError(({ networkError }) => {
    if (networkError.statusCode === 401) {
        console.log("permissions error");
    }
    else {
        console.log("other network error: ", networkError);
    }
})

// debug wrapper
const loggerLink = new ApolloLink((operation, forward) => {
    //  console.log(`GraphQL Request: ${operation.operationName}`);
    //console.log("GraphQL query: ", operation.query);
    //console.log("GraphQL vars:", operation.variables);
  operation.setContext({ start: new Date() });
  return forward(operation).map((response) => {
    const responseTime = new Date() - operation.getContext().start;
    console.log(`GraphQL Response took: ${responseTime}`);
      //console.log("GraphQL Response :", response.data);
    return response;
  });
});

const links = ApolloLink.from([
    permissionsLink,
    loggerLink,
    link,
]);

const client = new ApolloClient({
  // Provide required constructor fields
  cache: cache,
  link: links,

  // Provide some optional constructor fields
    // name: 'react-web-client',
    //version: '1.3',
  queryDeduplication: false,
  connectToDevTools: true,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
  }
});


const theme = createMuiTheme({
  palette: {
    type: 'dark', // Switching the dark mode on is a single property value change.
  },
});

class App extends Component {
	constructor() {
		super();
		this.state = { dataProvider: null};
    }
    componentDidMount() {
        (async () => {
            do {
                try {
                    const dataProvider = await pgDataProvider( client, {}, { introspection: { schema } });
                       this.setState({dataProvider});
                    break;
                } catch (err){}
                var ms=500;
                await new Promise(resolve => setTimeout(() => resolve(), ms));
            } while (true); 
        })();
    }
	render() {
        const { dataProvider } = this.state;

		if (!dataProvider) {
			return <div>Loading</div>;
		}
		return (
			<Admin theme={theme} dashboard={Dashboard} authProvider={authProvider} loginPage={loginPage}  dataProvider={dataProvider}>
                <Resource name="Idp" list={IdpList} edit={IdpEdit} show={IdpShow} create={IdpCreate}/>
                <Resource name="Client" list={ClientList} edit={ClientEdit} show={ClientShow} create={ClientCreate}/>
                <Resource name="Scope" list={ScopeList} edit={ScopeEdit} show={ScopeShow} create={ScopeCreate}/>
                <Resource name="Rule" list={RuleList}  edit={RuleEdit} show={RuleShow} create={RuleCreate}/>
                <Resource name="ClientScope"/>
                <Resource name="ClientIdpView" />
                <Resource name="ClientScopeView" />
                <Resource name="ClientValidationView" />
                <Resource name="ScopeRuleView" />
                <Resource name="ScopeTokenruleView" />
                <Resource name="ValidationApplicationView" />
                <Resource name="ValidationAttestationView" />
			</Admin>
		);
	}
}
            /*
			<Admin customRoots={customRoots} authProvider={authProvider} dataProvider={dataProvider}>
                <Resource name="Validation" list={ListGuesser} />
                <Resource name="Application" list={ListGuesser} />
                <Resource name="Attestation" list={ListGuesser} />
                <Resource name="CertChain" list={ListGuesser} />
                <Resource name="Cert" list={ListGuesser} />
                */
export default App;
